import React from "react";
import logo1 from "./icons/power-meter.png"
import logo2 from "./icons/home.png"
export default function Projects(){
    return (
        <div className="project-container">
            <h1 className="project-section-title">Projects</h1>
            <div className="project-display">
                <div className="project-item">
                    <img src={logo1} alt="" />
                    <h1 className="p-item-name">E-Meter (Iot)</h1>
                    <p className="p-item-content">The IoT Electric Meter is a smart device that integrates Internet of Things (IoT) technology to monitor and manage electricity consumption in real-time. It enables accurate data collection, remote monitoring, and facilitates efficient energy management for improved sustainability and cost-effectiveness.</p>
                </div>
                <div className="project-item">
                    <img src={logo2} alt="" srcset="" />
                    <h1 className="p-item-name">SmartSwitch (Iot)</h1>
                    <p className="p-item-content">The SmartSwitch project aims to revolutionize home automation by leveraging IoT technology to enable seamless control of switches in households. By integrating smart devices and utilizing the power of connectivity, this project offers an innovative solution to enhance convenience, energy efficiency, and overall home management.</p>
                </div>
            </div>
        </div>
    )
}